import { getBaseURL } from "./client";
const API_BASE_URL = getBaseURL();
const authApi = {
    async login(username, password) {
        const response = await fetch(`${API_BASE_URL}/auth/login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ username, password }),
        });
        const ct = response.headers.get("content-type") || "";
        const isJson = ct.includes("application/json");
        let result = {};
        if (isJson) {
            try {
                result = (await response.json());
            }
            catch {
                result = { error: "Sunucu yanıtı çözümlenemedi." };
            }
        }
        else {
            const snippet = (await response.text()).slice(0, 200);
            result = {
                error: response.status === 404
                    ? "API yolu bulunamadı (404). Backend çalışıyor mu? Geliştirmede `npm run serve` için vue.config.js içindeki /api → Flask proxy'si gerekir (varsayılan 127.0.0.1:5000)."
                    : snippet || response.statusText || "Beklenmeyen yanıt",
            };
        }
        return { response, result };
    },
    async logout(token) {
        if (!token)
            return;
        await fetch(`${API_BASE_URL}/auth/logout`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
    },
    async getCurrentUser(authHeaders) {
        const response = await fetch(`${API_BASE_URL}/auth/me`, {
            method: "GET",
            headers: authHeaders,
        });
        let result = null;
        if (response.ok) {
            result = await response.json();
        }
        return { response, result };
    },
    async getTenantLicense(authHeaders) {
        const response = await fetch(`${API_BASE_URL}/tenant/license`, {
            method: "GET",
            headers: authHeaders,
        });
        const result = await response.json();
        return { response, result };
    },
    async getTenantModules(authHeaders) {
        const response = await fetch(`${API_BASE_URL}/tenant/modules`, {
            method: "GET",
            headers: authHeaders,
        });
        const result = await response.json();
        return { response, result };
    },
};
export default authApi;
